export enum TrackShipmentsPath {
  accountNumber = "accountNumber",
  shipmentGroup = "shipmentGroup",
}

export interface PathParams {
  [TrackShipmentsPath.accountNumber]: string;
  [TrackShipmentsPath.shipmentGroup]: string;
}
